import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const CardioSelectedIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="20" height="30" viewBox="0 0 20 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect y="10" width="2" height="20" rx="1" transform="rotate(-90 0 10)" fill="#F27735" />
    <rect opacity="0.4" x="20" y="12" width="2" height="15" rx="1" transform="rotate(90 20 12)" fill="#F27735" />
    <rect x="20" y="16" width="2" height="10" rx="1" transform="rotate(90 20 16)" fill="#F27735" />
    <rect opacity="0.4" x="20" y="20" width="2" height="5" rx="1" transform="rotate(90 20 20)" fill="#F27735" />
  </svg>
)

export const CardioIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="20" height="30" viewBox="0 0 20 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect y="10" width="2" height="20" rx="1" transform="rotate(-90 0 10)" fill="#959693" />
    <rect opacity="0.4" x="20" y="12" width="2" height="15" rx="1" transform="rotate(90 20 12)" fill="#959693" />
    <rect x="20" y="16" width="2" height="10" rx="1" transform="rotate(90 20 16)" fill="#959693" />
    <rect opacity="0.4" x="20" y="20" width="2" height="5" rx="1" transform="rotate(90 20 20)" fill="#959693" />
  </svg>
)
